export default __webpack_public_path__ + "resources/icons/d211-f58a.png";